import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.operation.logs');
import { OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-operation-logs',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.operation.logs/view.scss */
:host {
  display: block;
  --ol-bg: #fff;
  --ol-soft: #f1f5f9;
  --ol-title: #203750;
  --ol-text: #40536b;
  --ol-muted: #63748a;
  --ol-line: #dce5ee;
  --ol-accent: #175d9c;
  --ol-hover: #eaf2fc;
  color: var(--ol-text);
}

:host-context(html.dark) {
  --ol-bg: #1e293b;
  --ol-soft: #263449;
  --ol-title: #e2e8f0;
  --ol-text: #cbd5e1;
  --ol-muted: #9cacc1;
  --ol-line: #3a4a60;
  --ol-accent: #8abcf0;
  --ol-hover: #2b405c;
}

.operation-logs {
  min-width: 0;
}

button:focus-visible, input:focus-visible, select:focus-visible, summary:focus-visible {
  outline: 3px solid #80b0e6;
  outline-offset: 3px;
}

.ol-heading {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  margin-bottom: 18px;
}

.ol-stats {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 24px;
  font-size: 13px;
}

.ol-stats strong {
  margin-left: 5px;
  font-size: 17px;
  font-weight: 650;
}

.ol-button {
  border: 0;
  border-radius: 8px;
  background: var(--ol-soft);
  color: var(--ol-accent);
  padding: 10px 15px;
  white-space: nowrap;
  cursor: pointer;
  font-size: 13px;
}

.ol-button.primary {
  background: #175d9c;
  color: #fff;
}

.ol-button:disabled {
  opacity: 0.45;
  cursor: default;
}

.ol-button i {
  margin-right: 6px;
}

.success {
  color: #267047;
}

.warning {
  color: #a56515;
}

.failure {
  color: #b53e48;
}

.ol-filters {
  display: flex;
  gap: 14px;
  align-items: end;
  flex-wrap: wrap;
  background: var(--ol-bg);
  border-radius: 12px;
  padding: 18px;
  margin-bottom: 12px;
}

.ol-filters label {
  display: flex;
  flex-direction: column;
  gap: 7px;
  font-size: 12px;
  color: var(--ol-muted);
  flex: 1;
  min-width: 125px;
}

.ol-filters .ol-search {
  flex: 2;
  min-width: 250px;
}

.ol-filters input, .ol-filters select {
  width: 100%;
  height: 40px;
  border: 1px solid var(--ol-line);
  border-radius: 8px;
  padding: 9px 12px;
  background: var(--ol-bg);
  color: var(--ol-text);
  font-size: 13px;
}

.ol-note {
  color: var(--ol-muted);
  font-size: 12px;
  line-height: 1.6;
  margin: 0 0 14px;
}

.ol-layout {
  min-width: 0;
}

.ol-list {
  min-width: 0;
  border-radius: 12px;
  background: var(--ol-bg);
  overflow: hidden;
}

.ol-table-scroll {
  overflow: auto;
}

table {
  border-collapse: collapse;
  width: 100%;
  font-size: 13px;
}

th {
  text-align: left;
  background: var(--ol-soft);
  color: var(--ol-muted);
  font-size: 12px;
  font-weight: 500;
  padding: 14px 18px;
  white-space: nowrap;
}

td {
  padding: 18px;
  border-top: 1px solid var(--ol-line);
  vertical-align: top;
  min-width: 85px;
}

td strong {
  display: block;
  font-weight: 600;
  color: var(--ol-title);
  overflow-wrap: anywhere;
}

td small {
  display: block;
  color: var(--ol-muted);
  margin-top: 6px;
  max-width: 280px;
  overflow-wrap: anywhere;
}

.ol-people, .ol-action {
  min-width: 145px;
}

.ol-time {
  white-space: nowrap;
  font-size: 12px;
  font-variant-numeric: tabular-nums;
}

.ol-row {
  cursor: pointer;
  transition: background 0.15s ease;
}

.ol-row:hover, .ol-row.selected, .ol-row:focus-visible {
  background: var(--ol-hover);
}

.ol-row:focus-visible {
  outline: 2px solid var(--ol-accent);
  outline-offset: -2px;
}

.ol-row:hover td strong {
  color: var(--ol-accent);
}

.ol-badge {
  display: inline-block;
  font-size: 11px;
  font-weight: 600;
  border-radius: 20px;
  padding: 4px 9px;
  white-space: nowrap;
}

.ol-badge.success {
  background: #eaf6ef;
}

.ol-badge.warning {
  background: #fff4db;
}

.ol-badge.failure {
  background: #fdecef;
}

.ol-link {
  border: 0;
  background: transparent;
  color: var(--ol-accent);
  font-weight: 600;
  font-size: 12px;
  cursor: pointer;
  white-space: nowrap;
}

.ol-pagination {
  display: flex;
  gap: 9px;
  align-items: center;
  padding: 15px 18px;
  border-top: 1px solid var(--ol-line);
}

.ol-pagination span {
  margin-right: auto;
  font-size: 12px;
  color: var(--ol-muted);
}

.ol-empty {
  padding: 60px 20px;
  text-align: center;
  color: var(--ol-muted);
}

.ol-error {
  padding: 15px;
  border-radius: 8px;
  background: #fdecef;
  color: #ad3445;
  margin-bottom: 15px;
  font-size: 13px;
}

.ol-detail {
  width: min(900px, 100vw - 48px);
  max-width: none;
  max-height: calc(100dvh - 64px);
  min-width: 0;
  margin: auto;
  border: 1px solid var(--ol-line);
  border-radius: 16px;
  padding: 0;
  color: var(--ol-text);
  background: var(--ol-bg);
  box-shadow: 0 24px 80px rgba(16, 36, 54, 0.2509803922);
  overflow: hidden;
}

.ol-detail::backdrop {
  background: rgba(15, 28, 43, 0.5);
}

.ol-modal-content {
  display: flex;
  flex-direction: column;
  max-height: inherit;
}

.ol-detail-body {
  padding: 0 28px 24px;
  overflow-y: auto;
  overscroll-behavior: contain;
  min-height: 0;
}

.ol-detail h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 650;
  color: var(--ol-title);
}

.ol-detail header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  padding: 24px 28px 20px;
  flex-shrink: 0;
}

.ol-detail p {
  font-size: 13px;
  line-height: 1.6;
  overflow-wrap: anywhere;
}

.ol-detail-tabs {
  display: flex;
  gap: 6px;
  padding: 4px;
  background: var(--ol-soft);
  border-radius: 8px;
  margin: 0 28px 20px;
  flex-shrink: 0;
}

.ol-detail-tabs button {
  flex: 1;
  border: 0;
  border-radius: 6px;
  padding: 9px 5px;
  background: transparent;
  color: var(--ol-muted);
  font-size: 13px;
  cursor: pointer;
}

.ol-detail-tabs button.active {
  background: var(--ol-bg);
  color: var(--ol-accent);
  font-weight: 650;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.0392156863);
}

.ol-detail-tabs button:disabled {
  opacity: 0.4;
  cursor: default;
}

.ol-request-status {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
  color: var(--ol-muted);
  font-size: 12px;
  margin-bottom: 16px;
}

.ol-facts {
  display: grid;
  grid-template-columns: 130px minmax(0, 1fr);
  gap: 9px 16px;
  margin: 0;
  font-size: 13px;
  line-height: 1.6;
}

.ol-facts dt {
  color: var(--ol-muted);
  font-weight: 400;
}

.ol-facts dd {
  margin: 0;
  color: var(--ol-title);
  overflow-wrap: anywhere;
}

.ol-request-facts {
  margin-bottom: 18px;
}

.ol-person-links {
  display: flex;
  gap: 12px;
  margin-top: 8px;
}

.ol-flow-title {
  margin: 20px 0 0;
  font-size: 14px;
  font-weight: 600;
  color: var(--ol-title);
}

.ol-person-summary {
  border-bottom: 1px solid var(--ol-line);
  padding-bottom: 10px;
  margin-bottom: 16px;
}

.ol-person-summary p {
  margin: 8px 0;
}

.ol-person-summary span {
  display: inline-block;
  min-width: 82px;
  color: var(--ol-muted);
}

.ol-cause {
  padding: 14px 16px;
  border-radius: 8px;
  background: #fff6e5;
  color: #705820;
  margin-bottom: 16px;
}

.ol-cause strong {
  font-size: 12px;
}

.ol-cause p {
  margin: 6px 0;
}

.ol-cause small {
  font-size: 12px;
  line-height: 1.7;
  display: block;
}

.ol-technical {
  margin: 10px 0;
  font-size: 12px;
  color: var(--ol-muted);
}

.ol-technical summary {
  cursor: pointer;
  width: fit-content;
}

.ol-technical code {
  display: block;
  margin-top: 8px;
  overflow-wrap: anywhere;
  color: inherit;
  font-size: 11px;
}

.ol-timeline {
  list-style: none;
  padding: 0;
  margin: 20px 0 0;
}

.ol-timeline li {
  border-left: 2px solid var(--ol-line);
  padding: 0 0 22px 16px;
}

.ol-timeline li:last-child {
  padding-bottom: 0;
}

.ol-step-title {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  align-items: center;
  font-size: 14px;
  margin-bottom: 8px;
  color: var(--ol-title);
}

.ol-timeline small {
  font-size: 12px;
  color: var(--ol-muted);
}

.ol-timeline p {
  margin: 8px 0;
}

.ol-timeline dl {
  font-size: 12px;
  margin: 10px 0;
  overflow-wrap: anywhere;
}

.ol-timeline dt {
  color: var(--ol-muted);
  font-weight: 400;
}

.ol-timeline dd {
  margin: 3px 0 10px;
}

.ol-history-title {
  font-size: 16px;
  font-weight: 650;
  margin: 0 0 10px;
  color: var(--ol-title);
}

.ol-history {
  display: grid;
  gap: 10px;
  margin-bottom: 18px;
}

.ol-history .ol-history-row {
  border: 1px solid var(--ol-line);
  border-radius: 10px;
  padding: 16px;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.ol-history-row:hover, .ol-history-row:focus-visible {
  background: var(--ol-hover);
  border-color: var(--ol-accent);
}

.ol-history-row:focus-visible {
  outline: 2px solid var(--ol-accent);
  outline-offset: 2px;
}

@media (max-width: 600px) {
  .ol-heading {
    align-items: start;
  }
  .ol-stats {
    gap: 10px 16px;
  }
  .ol-stats strong {
    font-size: 15px;
  }
  .ol-filters {
    padding: 14px;
  }
  .ol-filters label {
    min-width: 120px;
  }
  .ol-filters .ol-search {
    min-width: 100%;
  }
  .ol-pagination {
    flex-wrap: wrap;
  }
  .ol-detail {
    width: calc(100vw - 20px);
    max-height: calc(100dvh - 24px);
    border-radius: 12px;
  }
  .ol-detail header {
    padding: 18px 16px 14px;
  }
  .ol-detail h2 {
    font-size: 17px;
  }
  .ol-detail-tabs {
    margin: 0 16px 16px;
  }
  .ol-detail-body {
    padding: 0 16px 18px;
  }
  .ol-step-title {
    align-items: flex-start;
  }
  .ol-facts {
    grid-template-columns: 106px minmax(0, 1fr);
    gap: 8px 10px;
    font-size: 12px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .ol-row, .ol-history-row {
    transition: none;
  }
}`],
})
export class ComponentOperationLogsComponent implements OnInit, OnDestroy {
    constructor(@Inject( Service) public service: Service) {}
    @ViewChild('detailDialog') detailDialog: ElementRef<HTMLDialogElement>;
    private bodyOverflow: string | null = null;
    private destroyed = false;
    private async showModal() {
        await this.service.render();
        const dialog = this.detailDialog?.nativeElement;
        dialog?.querySelector('.ol-detail-body')?.scrollTo({top: 0});
        if (this.destroyed || !this.selected || !dialog || dialog.open) return;
        this.bodyOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        dialog.showModal();
    }
    private releaseModal() {
        this.detailDialog?.nativeElement.close();
        if (this.bodyOverflow !== null) {
            document.body.style.overflow = this.bodyOverflow;
            this.bodyOverflow = null;
        }
    }
    public backdrop(event: MouseEvent) {
        const dialog = this.detailDialog?.nativeElement;
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right ||
            event.clientY < rect.top || event.clientY > rect.bottom) this.close();
    }
    public filters = {text: '', result: '', start: '', end: ''};
    public rows: any[] = [];
    public counts: any = {};
    public total = 0;
    public page = 1;
    public lastpage = 1;
    public snapshot = '';
    public loading = false;
    public error = '';
    public selected: any = null;
    public steps: any[] = [];
    public detailLoading = false;
    public detailError = '';
    public truncated = false;
    public ready = false;
    public detailTab = 'request';
    public historyRows: any[] = [];
    public historyLoading = false;
    public historyError = '';
    public historyLabel = '';
    public historyProvisional = false;
    public historyPage = 1;
    public historyLastpage = 1;
    public historyTotal = 0;
    private historySnapshot = '';
    private historySeed: any = null;
    private historyPerson = 'target';
    private historySequence = 0;
    private sequence = 0;
    private detailSequence = 0;
    public categories: any = {web: '웹 처리', gateway: 'LDAP 게이트웨이', mail: '이메일'};
    public results: any = {success: '성공', warning: '확인 필요', failure: '실패'};
    public async ngOnInit() {
        await this.service.init();
        if (this.service.auth.session?.role !== 'admin') return;
        const now = new Date();
        this.filters.end = this.kstDate(now);
        this.filters.start = this.kstDate(new Date(now.getTime() - 6 * 86400000));
        this.ready = true;
        await this.load(true);
    }
    private kstDate(date: Date) { return new Date(date.getTime() + 9 * 3600000).toISOString().slice(0, 10); }
    public ngOnDestroy() { this.destroyed = true; this.sequence++; this.detailSequence++; this.historySequence++; this.releaseModal(); }
    public async load(reset = false, nextPage?: number) {
        const seq = ++this.sequence;
        this.loading = true; this.error = '';
        this.close(); this.steps = [];
        if (reset) { this.page = 1; this.snapshot = ''; }
        try {
            const response = await wiz.call('search', {...this.filters, page: nextPage || this.page, snapshot: this.snapshot});
            if (seq !== this.sequence) return;
            if (response.code !== 200) throw new Error(typeof response.data === 'string' ? response.data : '로그를 조회하지 못했습니다.');
            const data = response.data;
            this.rows = data.rows; this.total = data.total; this.counts = data.counts;
            this.page = data.page; this.lastpage = data.lastpage; this.snapshot = data.snapshot;
        } catch (e: any) {
            if (seq !== this.sequence) return;
            this.error = e?.message || '로그를 조회하지 못했습니다.';
            this.rows = []; this.total = 0; this.counts = {};
        } finally {
            if (seq === this.sequence) { this.loading = false; await this.service.render(); }
        }
    }
    public async reset() {
        this.filters = {...this.filters, text: '', result: ''};
        await this.load(true);
    }
    public async open(row: any, fromHistory = false) {
        const seq = ++this.detailSequence;
        this.selected = row; this.steps = []; this.detailError = ''; this.detailLoading = true;
        this.detailTab = 'request';
        if (!fromHistory) {
            this.historySequence++; this.historySeed = null; this.historyRows = [];
            this.historyError = ''; this.historyLabel = '';
        }
        await this.showModal();
        if (seq !== this.detailSequence) return;
        try {
            const response = await wiz.call('trace', {request_id: row.request_id});
            if (seq !== this.detailSequence) return;
            if (response.code !== 200) throw new Error(typeof response.data === 'string' ? response.data : '상세 조회에 실패했습니다.');
            this.steps = response.data.rows.map((step: any) => ({...step, metadata: this.info(step.details), technical: this.info(step.details, true)})); this.truncated = response.data.truncated;
        } catch (e: any) {
            if (seq === this.detailSequence) this.detailError = e?.message || '상세 조회에 실패했습니다.';
        } finally {
            if (seq === this.detailSequence) { this.detailLoading = false; await this.service.render(); }
        }
    }
    public close(event?: Event) { event?.preventDefault(); this.detailSequence++; this.historySequence++; this.releaseModal(); this.selected = null; }
    public activate(event: MouseEvent | KeyboardEvent, row: any, fromHistory = false) {
        (event.currentTarget as HTMLElement)?.focus();
        return this.open(row, fromHistory);
    }
    public rowKey(event: KeyboardEvent, row: any, fromHistory = false) {
        if (event.target !== event.currentTarget || !['Enter', ' '].includes(event.key)) return;
        event.preventDefault();
        this.activate(event, row, fromHistory);
    }
    public actionLabel(row: any) { return row.display?.title || '웹서비스 이용'; }
    public userLabel(row: any) {
        return row.display?.user || row.context?.user?.label || '사용자 정보 없음';
    }
    public actorLabel(row: any) { return row.context?.actor?.label || row.actor || '계정 정보 없음'; }
    public targetLabel(row: any) {
        const c = row.context || {};
        const self = !c.claimed && c.user?.key && c.user.key === c.actor?.key;
        return [self ? '본인' : c.user?.label, c.group?.label, c.request?.label].filter(Boolean).join(' · ') || row.subject || '대상 정보 없음';
    }
    public canHistory(row: any, person = 'target') {
        return person === 'actor' ? !!(row.context?.actor?.key || row.actor_id) : !!row.context?.user?.key;
    }
    public async showHistory(row: any, person = 'target', page = 1) {
        const same = this.historySeed?.id === row.id && this.historyPerson === person;
        if (!same) { this.historySnapshot = ''; this.historyRows = []; }
        this.historySeed = row; this.historyPerson = person;
        this.selected = row; this.detailSequence++; this.detailTab = 'history';
        this.historyLoading = true; this.historyError = '';
        const seq = ++this.historySequence;
        await this.showModal();
        if (seq !== this.historySequence) return;
        try {
            const response = await wiz.call('history', {
                event_id: row.id, person, start: this.filters.start, end: this.filters.end,
                page, snapshot: this.historySnapshot
            });
            if (seq !== this.historySequence) return;
            if (response.code !== 200) throw new Error(typeof response.data === 'string' ? response.data : '사용자 이력을 조회하지 못했습니다.');
            const data = response.data;
            this.historyRows = data.rows; this.historyPage = data.page; this.historyLastpage = data.lastpage;
            this.historyTotal = data.total; this.historySnapshot = data.snapshot;
            this.historyLabel = data.person.label; this.historyProvisional = data.person.provisional;
        } catch (e: any) {
            if (seq === this.historySequence) { this.historyError = e?.message || '이력을 조회하지 못했습니다.'; this.historyRows = []; }
        } finally {
            if (seq === this.historySequence) { this.historyLoading = false; await this.service.render(); }
        }
    }
    public historyTab() {
        const row = this.historySeed || this.selected;
        const person = this.historySeed ? this.historyPerson : this.canHistory(row) ? 'target' : 'actor';
        return this.showHistory(row, person, this.historySeed ? this.historyPage : 1);
    }
    public historyNext(page: number) { return this.showHistory(this.historySeed, this.historyPerson, page); }
    public time(value: string) { return value ? value.slice(0, 19).replace('T', ' ') : ''; }
    public info(value: any, technical = false) {
        const labels: any = {new_ldap: '신형 LDAP', old_ldap: '구형 LDAP', verified: '반영 확인', verify_next: '재검증 필요',
            stage: '응답 단계', first_login: '최초 포털 가입 필요', password_verified: '비밀번호 설정', otp_issuance: 'OTP 설정', password: '비밀번호 초기화', otp: 'OTP 초기화', database: '포털 DB 저장', portal: '포털 DB 저장', ldap: 'LDAP 반영', mail: '이메일 발송', Y: '완료', N: '미완료', status: '상태', error_code: '오류 코드', gateway_request_id: '게이트웨이 요청 번호',
            delivery: '메일 전달', accepted_by_smtp: 'SMTP 서버 접수 완료', not_confirmed: '접수 확인 실패',
            applied: '반영 완료', not_found: '대상 없음', failed: '실패', not_attempted: '미시도', unknown: '미확인',
            skipped: '생략', exists: '존재', deleted: '삭제 완료', removed: '탈퇴 완료', not_member: '소속 아님',
            retry: '재시도 필요', mail_sent: '메일 발송', email_sent: '이메일 발송', notification_sent: '알림 발송',
            completed: '처리 완료', otp_finalized: 'OTP 설정 완료', password_change_required: '비밀번호 변경 필요', outcome: '결과'};
        const format = (v: any): string => typeof v === 'boolean' ? (v ? '예' : '아니오')
            : v && typeof v === 'object' ? Object.entries(v).map(([k, x]) => (labels[k] || k) + ': ' + format(x)).join(' · ')
            : labels[v] || String(v);
        return Object.entries(value || {}).filter(([key]) => key !== 'related_issues' && (['error_code', 'gateway_request_id'].includes(key) === technical)).map(([key, v]) => ({key: labels[key] || key, value: format(v)}));
    }
}

export default ComponentOperationLogsComponent;